import React, { useState, useEffect } from "react";
import { useIntl, FormattedMessage } from "react-intl";

import { Card } from "../../common/card/card";
import { Header } from "../../common/title/header";
import { Button as MuiButton, Grid, makeStyles, CircularProgress } from "@material-ui/core";
import { useWorkOrderStyles, Caption, Value, CardTitle } from "../workOrderDetails";
import LocatesList from "./LocatesList";
import { STATUSES } from "../../../globals/workOrderStatus";
import DuplicateWOWarningPopup from "../../workOrderActions/duplicateTruckRollWarningPopup";
import FollowUpsList from "./FollowUpsList";
import moment from "moment";
import { useLocalizedName } from "../../../globals/langHelpers";

const disableEditStatuses = [STATUSES.BELL_BILLING_APPROVAL, STATUSES.BILLING_APPROVED, STATUSES.CANCELLED];

export const useEntryStyle = makeStyles({
    entryContainer: {
        padding: "12px",
        background: "#ffffff",
        borderRadius: "4px",
        fontFamily: "Arial",
        border: "1px solid rgba(0,0,0,.125)",
    },
    relatedWorkOrderDetailDetails: {
        color: "#555555",
        fontSize: "14px",
        lineHeight: "16px",
    },
    relatedWorkOrderDetailData: {
        color: "#111111",
        fontSize: "14px",
        lineHeight: "16px",
        fontWeight: "bold",
        "& .MuiGrid-grid-xs-2": {
            whiteSpace: "normal !important",
        },
    },
});

const getFormattedDate = (assignDate, separator = "/") => {
    if (assignDate === null || assignDate === undefined) return "";

    return moment(assignDate).format("MMM DD, YYYY");
    // let fullDate = new Date(assignDate);
    // let date = fullDate.getDate();
    // let month = fullDate.getMonth() + 1;
    // let year = fullDate.getFullYear();
    // // YYYY/MM/DD
    // return `${year}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${date}`;
};

const RelatedWork = ({ workorderData, relatedIdInformation, orderedRelatedWOData, relatedWOList, triggerPopup, setTriggerPopup }) => {
    const classes = Object.assign(useEntryStyle(), useWorkOrderStyles());
    const [editLocates, setEditLocates] = useState(false);
    const [editFollowUps, setEditFollowUps] = useState(false);
    const readOnly = workorderData?.status === undefined || disableEditStatuses?.includes(workorderData?.status?.id);
    const { getLocalizedName } = useLocalizedName();
    const openWOInNewWindow = (workOrderIdRef) => {
        const work_order_id = workOrderIdRef;
        window.open(window.location.origin + "/workorderdetails/" + work_order_id);
    };
    const handleLocateSave = () => {
        setEditLocates(false);
    };
    const intl = useIntl();
    const getFormatedDate = (date) => {
        return date ? moment(date).utc().format("MMM DD, YYYY") : "";
    };
    const handleFollowUpsSave = () => {
        setEditFollowUps(false);
    };
    const workOrderList = workorderData && (
        <Grid container className={classes.relatedWorkOrderDetailData}>
            <Grid item container xs={3} style={{ color: "#00549A" }}>
                <a
                    className="WOId"
                    href="#"
                    onClick={(e) => {
                        e.stopPropagation();
                        openWOInNewWindow(workorderData?.workOrderNumber);
                    }}>
                    {workorderData?.workOrderNumber}
                </a>
            </Grid>
            <Grid item container xs={2}>
                {getLocalizedName({ object: workorderData?.activties })}
            </Grid>
            <Grid item container xs={2}>
                {workorderData?.appointmentDueDate ? (
                    getFormatedDate(workorderData?.appointmentDueDate)
                ) : (
                    <span style={{ marginLeft: "10px" }}>-</span>
                )}
            </Grid>
            <Grid item container xs={2}>
                {getLocalizedName({ object: workorderData?.status })}
            </Grid>
            <Grid item container xs={2}>
                {workorderData?.completionDate ? getFormatedDate(workorderData?.completionDate) : <span style={{ marginLeft: "10px" }}>-</span>}
            </Grid>
        </Grid>
    );

    const relatedOrdersList =
        orderedRelatedWOData &&
        orderedRelatedWOData?.length > 0 &&
        orderedRelatedWOData?.map((followUp, idx) => (
            <Grid container className={classes.relatedWorkOrderDetailData} key={followUp?.workOrderId || idx}>
                <Grid item xs={3} style={{ color: "#00549A" }}>
                    <a
                        className="WOId"
                        href="#"
                        onClick={(e) => {
                            e.stopPropagation();
                            openWOInNewWindow(followUp?.workOrderId);
                        }}>
                        {followUp?.workOrderId ? followUp?.workOrderId : ""}
                    </a>
                </Grid>
                <Grid item xs={2}>
                    {intl.locale === "en" ? followUp?.workActivity : followUp?.workActivity_fr}
                </Grid>
                <Grid item xs={2}>
                    {followUp?.appointmentDate != null ? getFormatedDate(followUp?.appointmentDate) : <span style={{ marginLeft: "10px" }}>-</span>}
                </Grid>
                <Grid item xs={2}>
                    {intl.locale === "en" ? followUp?.status : followUp?.status_fr}
                </Grid>
                <Grid item xs={2}>
                    {followUp?.woCompletionDate != null ? getFormatedDate(followUp?.woCompletionDate) : <span style={{ marginLeft: "10px" }}>-</span>}
                </Grid>
            </Grid>
        ));

    return (
        <div>
            {workorderData?.workOrderNumber || relatedIdInformation?.length > 0 ? (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Header>
                            <FormattedMessage
                                id="admin.work-order-details.releated-work.work-orders-title"
                                defaultMessage="Related work orders"
                                description="Admin Related work orders title"
                            />
                        </Header>
                    </Grid>
                    <Grid item xs={12}>
                        <Card>
                            <Grid container className={classes.relatedWorkOrderDetailDetails}>
                                <Grid item xs={3}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.releated-work.work-order-number-caption"
                                            defaultMessage="Work order number"
                                            description="Work order number"
                                        />
                                    </Caption>
                                    <Value></Value>
                                </Grid>
                                <Grid item xs={2}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.releated-work.work-activity-title"
                                            defaultMessage="Work activity"
                                            description="Work activity"
                                        />
                                    </Caption>
                                    <Value></Value>
                                </Grid>
                                <Grid item xs={2}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.releated-work.appointment date-title"
                                            defaultMessage="Appointment date"
                                            description="Admin Related Appointment date title"
                                        />
                                    </Caption>
                                    <Value></Value>
                                </Grid>
                                <Grid item xs={2}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.releated-work.status-title"
                                            defaultMessage="Status"
                                            description="Admin Related Status title"
                                        />
                                    </Caption>
                                    <Value></Value>
                                </Grid>
                                <Grid item xs={2}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.releated-work.wo-completion-date-title"
                                            defaultMessage="WO Completion Date"
                                            description="Admin Related WO Completion Date title"
                                        />
                                    </Caption>
                                    <Value></Value>
                                </Grid>
                            </Grid>
                            {relatedOrdersList}
                        </Card>
                    </Grid>

                    {triggerPopup && <DuplicateWOWarningPopup open={triggerPopup} setOpen={setTriggerPopup} />}
                    {process.env.REACT_APP_FEATURE_CMISR3 === "true" && (
                        <>
                            <Grid item xs={12}>
                                <Header>
                                    <FormattedMessage
                                        id="admin.work-order-details.releated-work.follow-ups-title"
                                        defaultMessage="Follow-ups"
                                        description="Admin work order follow ups"
                                    />
                                </Header>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container className={classes.entryContainer}>
                                    <Grid item xs={12}>
                                        <CardTitle style={{ marginBottom: "0px" }}>
                                            <FormattedMessage
                                                id="admin.work-order-details.releated-work.follow-ups-title"
                                                defaultMessage="Follow ups"
                                                description="Admin work order follow ups"
                                            />
                                        </CardTitle>
                                        {/* {editFollowUps ||
                                        <MuiButton
                                            className="no-print"
                                            disabled={readOnly}
                                            onClick={() => setEditFollowUps(true)}>
                                            <FormattedMessage
                                                id='admin.work-order-details.edit'
                                                defaultMessage='Edit'
                                                description='Admin work order edit button'
                                            />
                                        </MuiButton>} */}
                                    </Grid>
                                </Grid>
                                <FollowUpsList
                                    workorderData={workorderData}
                                    relatedIdInformation={relatedIdInformation}
                                    edit={editFollowUps}
                                    onSave={handleFollowUpsSave}
                                    onClose={handleFollowUpsSave}
                                />
                            </Grid>
                        </>
                    )}
                    {process.env.REACT_APP_FEATURE_CMISR3 === "true" && (
                        <>
                            <Grid item xs={12}>
                                <Header>
                                    <FormattedMessage
                                        id="admin.work-order-details.releated-work.Locates-title"
                                        defaultMessage="Locates"
                                        description="Admin work order Locates"
                                    />
                                </Header>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container className={classes.entryContainer}>
                                    <Grid item xs={12}>
                                        <CardTitle style={{ marginBottom: "0px" }}>
                                            <FormattedMessage
                                                id="admin.work-order-details.releated-work.Locates-title"
                                                defaultMessage="Locates"
                                                description="Admin work order Locates"
                                            />
                                        </CardTitle>
                                        {editLocates || (
                                            <MuiButton className="no-print" disabled={readOnly} onClick={() => setEditLocates(true)}>
                                                <FormattedMessage
                                                    id="admin.work-order-details.edit"
                                                    defaultMessage="Edit"
                                                    description="Admin work order edit button"
                                                />
                                            </MuiButton>
                                        )}
                                    </Grid>
                                </Grid>
                                <LocatesList
                                    workorderData={workorderData}
                                    relatedIdInformation={relatedIdInformation}
                                    edit={editLocates}
                                    onSave={handleLocateSave}
                                    onClose={handleLocateSave}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            ) : (
                <div className={classes.spinner}>
                    <CircularProgress />
                </div>
            )}
        </div>
    );
};

export default RelatedWork;
